const DELAYED_SELECTOR = 'script[type="propel-delayed-script"]';

const INTERACTION_EVENTS = [
	'scroll',
	'mousemove',
	'touchstart',
	'pointerdown',
	'keydown',
	'focusin',
];

let queue = Promise.resolve();

// A fresh element is needed to run the script; the original was already processed with a non-JS type.
const runScript = (original) =>
	new Promise((resolve) => {
		const script = document.createElement('script');
		const skippedAttributes = ['type', 'data-type', 'data-delay'];

		Array.from(original.attributes).forEach(({ name, value }) => {
			if (!skippedAttributes.includes(name)) {
				script.setAttribute(name, value);
			}
		});

		if (original.dataset.type) {
			script.type = original.dataset.type;
		}

		if (script.src) {
			script.async = false;
			script.addEventListener('load', resolve);
			script.addEventListener('error', resolve);
		} else {
			script.textContent = original.textContent;
		}

		original.replaceWith(script);

		if (!script.src) {
			resolve();
		}
	});

// Scripts run one at a time in document order, so inline scripts never run before the files they depend on.
const loadScripts = (selector) => {
	document.querySelectorAll(selector).forEach((script) => {
		script.type = 'propel-delayed-script-queued';
		queue = queue.then(() => runScript(script));
	});
};

const onInteraction = () => {
	INTERACTION_EVENTS.forEach((event) => {
		document.removeEventListener(event, onInteraction);
	});

	loadScripts(DELAYED_SELECTOR);
};

const delayedScripts = () => {
	INTERACTION_EVENTS.forEach((event) => {
		document.addEventListener(event, onInteraction, { passive: true });
	});

	// Scripts marked `data-delay="interaction"` only load on interaction, never on the timer.
	setTimeout(() => {
		loadScripts(`${DELAYED_SELECTOR}:not([data-delay="interaction"])`);
	}, 3500);
};

export default delayedScripts;
